module.exports = __webpack_public_path__ + "static/media/logosmartyellowdots.ceb0374f.svg";